import { EventEmitter } from "eventemitter3";

export const topUpEvents = new EventEmitter();

export const TOP_UP_REQUIRED = "TOP_UP_REQUIRED";
